import React from "react";
import ReactSelect from "react-select";
import styles from "./Select.module.scss";
import { ErrorMessage, Field, useFormikContext } from "formik";
import ErrorText from "components/shared/errortext/ErrorText";
import zIndex from "@mui/material/styles/zIndex";
import { combineClasses } from "utils/utils";

const Select = (props) => {
  const {
    label,
    name,
    placeholder,
    isRequired,
    isDisabled,
    options,
    optionsHeight,
    isMulti,
    style,
    inputClassName,
    ...rest
  } = props;
  const { setFieldValue } = useFormikContext(); // Access Formik context here

  const customStyles = {
    control: (provided) => ({
      ...provided,
      background: "none",
      border: "none",
      minHeight: "28px",
      height: isMulti ? "maxContent" : "28px",
      boxShadow: null,
      overflow: isMulti ? "auto !important" : "hidden",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: isMulti ? "maxContent" : "28px",
      padding: "0 8px",
      maxHeight: "50px",
      overflowY: "auto",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: optionsHeight || "100px",
    }),
    option: (provided) => ({
      ...provided,
      cursor: "pointer",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
      padding: "0",
      fontWeight: "600 !important",
      border: 0,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: isMulti ? "maxContent" : "28px",
    }),
  };

  return (
    <div className={styles.inputControl}>
      <label className={styles.label} htmlFor={name}>
        {label} {isRequired && <span className={styles.requiredMark}>*</span>}
      </label>
      <Field name={name} {...rest}>
        {({ field }) => (
          <div style={style} className={styles.inputField}>
            <ReactSelect
              {...field}
              {...rest}
              id={name}
              options={options}
              styles={customStyles}
              className={combineClasses(inputClassName)}
              onChange={(value) => setFieldValue(name, value)}
              placeholder={placeholder}
              classNamePrefix="react-select"
              isDisabled={isDisabled}
              isMulti={isMulti}
            />
          </div>
        )}
      </Field>
      <ErrorMessage name={name} component={ErrorText} />
    </div>
  );
};

export default Select;
